import { useEffect, useState, useCallback } from "react";

const THEME_KEY = "optishieldx-theme";

const getInitialTheme = () => {
  if (typeof window === "undefined") return "light";
  const stored = window.localStorage.getItem(THEME_KEY);
  if (stored === "light" || stored === "dark") return stored;
  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
};

export const useTheme = () => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    try {
      window.localStorage.setItem(THEME_KEY, theme);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to save theme preference:', error);
      }
    }
  }, [theme]); // THEME_KEY is a constant, root is derived from document

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  }, []); // setTheme is stable, prev is provided by the updater function

  return { theme, toggleTheme, setTheme };
};
